import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const PoetryContainer = styled.div`
  padding: 6rem 2rem 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const PoemCard = styled(motion.article)`
  background: ${props => props.theme.surface};
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px ${props => props.theme.border};
  margin-bottom: 2rem;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
`;

const PoemTitle = styled.h2`
  color: ${props => props.theme.surfaceText};
  margin-bottom: 0.5rem;
  transition: color 0.3s ease;
`;

const PoemDate = styled.p`
  color: ${props => props.theme.secondary};
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  transition: color 0.3s ease;
`;

const PoemContent = styled.pre`
  font-family: 'Georgia', serif;
  white-space: pre-wrap;
  line-height: 1.6;
  color: ${props => props.theme.surfaceText};
  transition: color 0.3s ease;
`;

const Poetry = () => {
  const poems = [
    {
      id: 1,
      title: 'Digital Verses',
      date: '2025-04-10',
      content: 'A digital symphony calls to me.\n\n' +
              'In this realm of ones and zeros,\n' +
              'Where algorithms dance like heroes,\n' +
              'I find poetry in code,\n' +
              'On this technological road.'
    },
    {
      id: 2,
      title: 'The Programmer\'s Solitude',
      date: '2025-03-25',
      content: 'Midnight keyboard clicking soft,\n' +
              'Lines of code stretch far aloft,\n' +
              'In solitude I write and think,\n' +
              'As stars and cursor both do blink.\n\n' +
              'Debug, refactor, test again,\n' +
              'Ideas flowing from my pen,\n' +
              'In this digital sanctuary,\n' +
              'My thoughts flow extraordinarily.'
    }
  ];

  return (
    <PoetryContainer>
      {poems.map((poem) => (
        <PoemCard
          key={poem.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <PoemTitle>{poem.title}</PoemTitle>
          <PoemDate>{poem.date}</PoemDate>
          <PoemContent>{poem.content}</PoemContent>
        </PoemCard>
      ))}
    </PoetryContainer>
  );
};

export default Poetry;
